"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1153],{

/***/ 31153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ClusterKeywords; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47568);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(39803);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(30585);
/* harmony import */ var _material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(44080);
/* harmony import */ var _utility_cr_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46236);
/* harmony import */ var _components_CollapsibleTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60872);
/* harmony import */ var _utility_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5969);
/* harmony import */ var _components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62412);
/* harmony import */ var _components_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53056);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34853);
/* harmony import */ var _components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97344);
/* harmony import */ var _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66306);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31955);
/* harmony import */ var _components_SkipCaptcha__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98950);
/* harmony import */ var _utility_services_customHooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89147);
/* harmony import */ var _components_CreditsInfo__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98910);
/* harmony import */ var _utility_tools_config__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(92061);



















var ClusterKeywords = function(param) {
    var classes = param.classes, setShowSignUpPage = param.setShowSignUpPage, user = param.user, hasValidSubscription = param.hasValidSubscription, resetLockedGrace = param.resetLockedGrace, enableLockedOption = param.enableLockedOption, handleResetUsage = param.handleResetUsage, _isQwaDashboard = param.isQwaDashboard, isQwaDashboard = _isQwaDashboard === void 0 ? false : _isQwaDashboard, _isCreditsShown = param.isCreditsShown, isCreditsShown = _isCreditsShown === void 0 ? false : _isCreditsShown, _creditsRemaining = param.creditsRemaining, creditsRemaining = _creditsRemaining === void 0 ? 0 : _creditsRemaining, _usagePerDay = param.usagePerDay, usagePerDay = _usagePerDay === void 0 ? 0 : _usagePerDay, setShowBuyOnePass = param.setShowBuyOnePass, setIsRedirectToWebflow = param.setIsRedirectToWebflow, _setShowMinimumCreditsNeededMsg = param.setShowMinimumCreditsNeededMsg, setShowMinimumCreditsNeededMsg = _setShowMinimumCreditsNeededMsg === void 0 ? function(a) {} : _setShowMinimumCreditsNeededMsg, setShowVerifyEmailPopup = param.setShowVerifyEmailPopup, _freeToolsUsage = param.freeToolsUsage, freeToolsUsage = _freeToolsUsage === void 0 ? 0 : _freeToolsUsage, _showFreeToolsUsage = param.showFreeToolsUsage, showFreeToolsUsage = _showFreeToolsUsage === void 0 ? false : _showFreeToolsUsage, _isCorpEmail = param.isCorpEmail, isCorpEmail = _isCorpEmail === void 0 ? false : _isCorpEmail;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), input = ref[0], setInput = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), cluster = ref1[0], setCluster = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), error = ref2[0], setError = ref2[1];
    var qttr_tools_auth = js_cookie__WEBPACK_IMPORTED_MODULE_11__/* ["default"].get */ .Z.get("qttr_tools_auth");
    var qttr_tools_daypass_auth = js_cookie__WEBPACK_IMPORTED_MODULE_11__/* ["default"].get */ .Z.get("qttr_tools_daypass_auth");
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), data = ref4[0], setData = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), recaptchaValue = ref5[0], setRecaptchaValue = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), captchaError = ref6[0], setCaptchaError = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), creditsNeeded = ref7[0], setCreditsNeeded = ref7[1];
    var session = (0,_utility_services_customHooks__WEBPACK_IMPORTED_MODULE_13__/* .useSession */ .kP)();
    var handleRecaptchaChange = function(value) {
        setRecaptchaValue(value);
        setCaptchaError("");
    };
    var clusterOptions = [
        "Search Intent",
        "User's Journey Stage In Search",
        "Jobs to be done",
        {
            name: "Landing Page H1",
            requireLogin: !hasValidSubscription && !enableLockedOption,
            icon: !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                className: classes.unlockIcon
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utility_tools_config__WEBPACK_IMPORTED_MODULE_15__/* .PremiumToolsIcon */ .WL, {})
        },
        {
            name: "Entities",
            requireLogin: !hasValidSubscription && !enableLockedOption,
            icon: !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                className: classes.unlockIcon
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utility_tools_config__WEBPACK_IMPORTED_MODULE_15__/* .PremiumToolsIcon */ .WL, {})
        },
        {
            name: "Brand Names",
            requireLogin: !hasValidSubscription && !enableLockedOption,
            icon: !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                className: classes.unlockIcon
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utility_tools_config__WEBPACK_IMPORTED_MODULE_15__/* .PremiumToolsIcon */ .WL, {})
        }, 
    ];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
            isAnonymousUser: !user,
            payload: {
                label: "Visited Free Tool",
                component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.cluster_keywords */ .vG.cluster_keywords,
                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research,
                isQwaDashboard: isQwaDashboard
            }
        });
    }, []);
    var handleChange = function(event) {
        var value = event.target.value;
        var option = clusterOptions.find(function(o) {
            return (typeof o === "string" ? o : o.name) === value;
        });
        if (option && (typeof option === "string" || !option.requireLogin)) {
            setCluster(value);
        } else {
            setShowSignUpPage("'cluster by ".concat(value, "'"), {
                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.cluster_keywords */ .vG.cluster_keywords,
                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research
            });
            (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
                eventFor: "button",
                buttonText: "",
                isAnonymousUser: !user,
                payload: {
                    label: "Clicked Locked Option",
                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.cluster_keywords */ .vG.cluster_keywords,
                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research,
                    option_name: "cluster by ".concat(value),
                    isQwaDashboard: isQwaDashboard
                }
            });
        }
        setError("");
    };
    var handleClusterKeywords = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res, axiosError;
            return _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        if (!(!input || !cluster)) {
                            _ctx.next = 5;
                            break;
                        }
                        // set errors
                        setError(!input && !cluster ? "input & cluster" : !input ? "input" : "cluster");
                        return _ctx.abrupt("return");
                    case 5:
                        (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
                            eventFor: "button",
                            buttonText: "",
                            counterName: "".concat(_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research, " Outputs"),
                            isAddCount: true,
                            user: user,
                            isAnonymousUser: !user,
                            payload: {
                                label: "Generate Output",
                                component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.cluster_keywords */ .vG.cluster_keywords,
                                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research,
                                special_instructions_yn: input ? "Yes" : "No",
                                isQwaDashboard: isQwaDashboard,
                                creditsConsumed: creditsNeeded ? creditsNeeded : 1
                            }
                        });
                        if (recaptchaValue || qttr_tools_auth || user) {
                            _ctx.next = 9;
                            break;
                        }
                        setCaptchaError("recaptchaValue");
                        return _ctx.abrupt("return");
                    case 9:
                        _ctx.next = 11;
                        return (0,_utility_cr_common__WEBPACK_IMPORTED_MODULE_3__/* .fetchAIBasedContent */ .LK)({
                            promptFor: "PUBLIC_UTILITY.CLUSTER_KEYWORDS",
                            promptConfig: {
                                keywords: input,
                                cluster_by: cluster
                            },
                            tokenLimit: 3500,
                            isPublicApi: true,
                            reCAPTCHAToken: recaptchaValue
                        });
                    case 11:
                        res = _ctx.sent;
                        setData(res.clusters);
                        if (handleResetUsage) {
                            handleResetUsage();
                        }
                        if (resetLockedGrace) {
                            resetLockedGrace();
                            setCluster("");
                        }
                        _ctx.next = 22;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                        axiosError = _ctx.t0;
                        if (axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) {
                            if (axiosError.response.status === 403) {
                                setShowSignUpPage(_components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_9__/* .CONTINUE_USING_TEXT */ .gt, {
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.cluster_keywords */ .vG.cluster_keywords,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research
                                });
                                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
                                    eventFor: "button",
                                    isAnonymousUser: !user,
                                    payload: {
                                        label: "Reached your maximum usage limit",
                                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.cluster_keywords */ .vG.cluster_keywords,
                                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research,
                                        isQwaDashboard: isQwaDashboard
                                    }
                                });
                            }
                        }
                        console.error("handleClusterKeywords:: ", _ctx.t0);
                    case 22:
                        _ctx.prev = 22;
                        setRecaptchaValue(null);
                        (0,_utility_common__WEBPACK_IMPORTED_MODULE_5__/* .resetCaptcha */ .Ler)();
                        setLoading(false);
                        return _ctx.finish(22);
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17,
                    22,
                    27
                ]
            ]);
        }));
        return function handleClusterKeywords() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleInputChange = function(event) {
        var value = event.target.value;
        var keywords = value.split(",");
        setError("");
        if (keywords.length > 50 && !hasValidSubscription && !enableLockedOption) {
            keywords = keywords.slice(0, 50); // Keep only the first 50 keywords
            setError("Please sign up to process more than 50 keywords.");
            setInput(keywords.join(","));
        } else {
            setInput(value);
        }
    };
    var handleDownload = function() {
        var ref = (0,_utility_common__WEBPACK_IMPORTED_MODULE_5__/* .createAnExcelSheet */ .mDv)("Discover Keywords"), ExcelJSWorkbook = ref.ExcelJSWorkbook, worksheet = ref.worksheet;
        // define columns for the worksheet
        worksheet.columns = [
            {
                header: "Cluster",
                key: "cluster",
                width: 20
            },
            {
                header: "Keyword",
                key: "keyword",
                width: 20
            },
            {
                header: "Search Volume",
                key: "search_volume",
                width: 15
            },
            {
                header: "Keyword Difficulty",
                key: "keyword_difficulty",
                width: 20
            }, 
        ];
        if (data && typeof data == "object" && !Array.isArray(data)) {
            for(var cluster in data){
                for(var keyword in data[cluster]){
                    // checking if data is for a keyword, not for the entire cluster
                    if (keyword !== "search volume" && keyword !== "keyword difficulty") {
                        worksheet.addRow({
                            cluster: cluster,
                            keyword: keyword,
                            search_volume: data[cluster][keyword]["search volume"],
                            keyword_difficulty: data[cluster][keyword]["keyword difficulty"]
                        });
                    }
                }
            }
        }
        (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
            eventFor: "button",
            buttonText: "",
            counterName: "Outputs Accepted",
            isAddCount: true,
            isAnonymousUser: !user,
            user: user,
            payload: {
                label: "Download Generated Output",
                component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.cluster_keywords */ .vG.cluster_keywords,
                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research,
                special_instructions_yn: input ? "Yes" : "No",
                isQwaDashboard: isQwaDashboard
            }
        });
        (0,_utility_common__WEBPACK_IMPORTED_MODULE_5__/* .downloadAnCsv */ .Ntz)(ExcelJSWorkbook, "quattr_generated_keyword_clusters");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var promptFor = _utility_common__WEBPACK_IMPORTED_MODULE_5__/* .PAID_TOOLS_PROMPT_FOR.CLUSTER_KEYWORDS */ .rMq.CLUSTER_KEYWORDS;
        var promptConfig = {
            keywords: input,
            cluster_by: cluster
        };
        setCreditsNeeded((0,_utility_common__WEBPACK_IMPORTED_MODULE_5__/* .getToolsUsageCreditsNeeded */ .Nmb)(promptFor, promptConfig));
    }, [
        user,
        input,
        cluster
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: classes.container,
        children: [
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_7__/* .QuattrLogoSpinner */ .h, {
                classes: classes
            }),
            data && Object.keys(data).length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CollapsibleTable__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        classes: classes,
                        data: {
                            clusters: data
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: classes.buttonGroup,
                        style: {
                            marginTop: "16px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                className: "".concat(classes.toolsYellowCTA, " ").concat(classes.toolsOutlinedCTA, "  ").concat(classes.button),
                                disabled: loading,
                                style: {
                                    float: "right"
                                },
                                onClick: function() {
                                    setData({});
                                    (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
                                        eventName: "Clicked on Go back",
                                        payload: {
                                            label: "Clicked on Go back"
                                        }
                                    });
                                },
                                children: "Go back"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                className: "".concat(classes.toolsYellowCTA, " ").concat(classes.button),
                                disabled: loading,
                                style: {
                                    float: "right"
                                },
                                onClick: handleDownload,
                                children: "Download Cluster List"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        multiline: true,
                        // fullWidth
                        value: input,
                        className: classes.textAreaInput,
                        onChange: handleInputChange,
                        maxRows: 5,
                        InputProps: {
                            style: {
                                backgroundColor: "#fff",
                                borderRadius: "4px !important",
                                padding: "16px"
                            },
                            disableUnderline: true
                        },
                        error: !!error,
                        minRows: 5,
                        helperText: error.includes("input") ? "* Required" : error.includes("Please sign up") ? error : "",
                        rows: 5,
                        variant: "filled",
                        placeholder: "Enter list of keywords separated by ,"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        value: cluster,
                        options: clusterOptions,
                        onChange: handleChange,
                        classes: classes,
                        label: "Cluster By",
                        error: error.includes("cluster") ? "* Required" : ""
                    }),
                    !qttr_tools_auth && !user && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                className: classes.recaptcha,
                                sitekey: "6LfNnmAqAAAAAFm-6SDC8c9lFenCJX2_QkckWpsd",
                                onChange: handleRecaptchaChange
                            }),
                            (captchaError === null || captchaError === void 0 ? void 0 : captchaError.includes("recaptchaValue")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                className: "red",
                                children: "Please complete the reCAPTCHA to verify you're human."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_SkipCaptcha__WEBPACK_IMPORTED_MODULE_12__/* .SkipCaptcha */ .h, {
                                classes: classes,
                                meta: {
                                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.cluster_keywords */ .vG.cluster_keywords,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research
                                },
                                setShowVerifyEmailPopup: setShowVerifyEmailPopup
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "".concat(isCreditsShown ? classes.creditsShown : classes.freeCreditsShown),
                        children: [
                            isCreditsShown ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CreditsInfo__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                classes: classes,
                                creditsRemaining: creditsRemaining,
                                creditsNeeded: creditsNeeded,
                                usagePerDay: usagePerDay
                            }) : !isQwaDashboard || showFreeToolsUsage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CreditsInfo__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                classes: classes,
                                creditsRemaining: freeToolsUsage,
                                creditsNeeded: creditsNeeded,
                                usagePerDay: isCorpEmail ? 10 : 7,
                                showFreeToolsUsage: showFreeToolsUsage
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "dflex j-flex-end ".concat(classes.buttonGroup),
                                style: {
                                    marginTop: "16px"
                                },
                                children: [
                                    !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                        style: {
                                            marginRight: "16px"
                                        },
                                        children: [
                                            input.split(",").filter(function(i) {
                                                return Boolean(i);
                                            }).length,
                                            "/50"
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        className: classes.toolsYellowCTA,
                                        disabled: loading,
                                        style: {
                                            float: "right"
                                        },
                                        onClick: function() {
                                            return (0,_utility_common__WEBPACK_IMPORTED_MODULE_5__/* .handleGenerateOutput */ .jx$)(creditsRemaining, creditsNeeded, isQwaDashboard, session, qttr_tools_daypass_auth, setShowMinimumCreditsNeededMsg, setShowBuyOnePass, handleClusterKeywords, _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec, freeToolsUsage, showFreeToolsUsage);
                                        },
                                        children: "Cluster Keyword List"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 60872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57394);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88222);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56847);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(79895);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7206);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(83750);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99613);
/* harmony import */ var _material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51115);
/* harmony import */ var _material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98121);
/* harmony import */ var _utility_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5969);
/* harmony import */ var _utility_services_keywordHelper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53041);








var useRowStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    root: {
        "& > *": {
            borderBottom: "unset"
        }
    }
});
function Row(props) {
    var cluster = props.cluster, name = props.name, parent_classes = props.parent_classes, isSingleLevel = props.isSingleLevel, keyName = props.keyName;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    var classes = useRowStyles();
    //   Object.keys(cluster).filter(key => typeof cluster[key] !== "object")
    var keys = isSingleLevel ? Object.keys(cluster).filter(function(i) {
        return i !== keyName;
    }) : [
        "search volume",
        "keyword difficulty"
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                className: "".concat(parent_classes.tableRow, " ").concat(classes.root),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        className: parent_classes.tableCell,
                        children: !isSingleLevel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            "aria-label": "expand row",
                            size: "small",
                            onClick: function() {
                                return setOpen(!open);
                            },
                            children: open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                        }) : null
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        className: parent_classes.tableCell,
                        scope: "row",
                        children: name
                    }),
                    keys.map(function(key, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            className: parent_classes.tableCell,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "keyword-difficulty-score-circle",
                                children: [
                                    typeof cluster[key] == "number" ? (0,_utility_common__WEBPACK_IMPORTED_MODULE_2__/* .numberFormatter */ .V2q)(cluster[key]) : cluster[key] || "--",
                                    key === "keyword difficulty" && (cluster[key] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "m-0",
                                        style: {
                                            width: "15px",
                                            height: "15px",
                                            borderRadius: "15px",
                                            background: (0,_utility_services_keywordHelper__WEBPACK_IMPORTED_MODULE_9__/* .getKeywordDificultyColorRange */ .XP)(cluster[key] || 0)
                                        }
                                    }) : null)
                                ]
                            })
                        }, index);
                    })
                ]
            }),
            name && Object.keys(cluster).filter(function(key) {
                return typeof cluster[key] === "object";
            }).map(function(subName, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "".concat(parent_classes.tableRow, " ").concat(classes.root),
                    children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: parent_classes.tableCell
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: parent_classes.tableCell,
                                scope: "row",
                                children: subName
                            }),
                            keys.map(function(key, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    className: parent_classes.tableCell,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "keyword-difficulty-score-circle",
                                        children: [
                                            typeof cluster[subName][key] == "number" ? (0,_utility_common__WEBPACK_IMPORTED_MODULE_2__/* .numberFormatter */ .V2q)(cluster[subName][key]) : cluster[subName][key] || "--",
                                            key === "keyword difficulty" && (cluster[subName][key] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "m-0",
                                                style: {
                                                    width: "15px",
                                                    height: "15px",
                                                    borderRadius: "15px",
                                                    background: (0,_utility_services_keywordHelper__WEBPACK_IMPORTED_MODULE_9__/* .getKeywordDificultyColorRange */ .XP)(cluster[subName][key] || 0)
                                                }
                                            }) : null)
                                        ]
                                    })
                                }, index);
                            })
                        ]
                    })
                }, index);
            })
        ]
    });
}
Row.propTypes = {
    name: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string.isRequired),
    cluster: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object.isRequired),
    parent_classes: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().any),
    isSingleLevel: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    keyName: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string)
};
var CollapsibleTable = function(param) {
    var data = param.data, isSingleLevel = param.isSingleLevel, classes = param.classes, keyName = param.keyName, columns = param.columns;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        component: _material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
        className: classes.tableWrap,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            "aria-label": "collapsible table",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    className: classes.tableHead,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: classes.tableHead,
                                width: "32px"
                            }),
                            (columns || [
                                {
                                    name: "Keyword Cluster"
                                },
                                {
                                    name: "Avg. Search Volume",
                                    width: "95px"
                                },
                                {
                                    name: "Keyword Difficulty",
                                    width: "81px"
                                }, 
                            ]).map(function(i) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    className: classes.tableHead,
                                    width: i.width,
                                    children: i.name
                                }, i.name);
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    children: data.clusters ? Array.isArray(data.clusters) && keyName ? data.clusters.map(function(obj) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, {
                            keyName: keyName,
                            name: obj[keyName],
                            parent_classes: classes,
                            cluster: obj,
                            isSingleLevel: isSingleLevel
                        }, obj[keyName]);
                    }) : Object.keys(data.clusters).map(function(name) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, {
                            name: name,
                            parent_classes: classes,
                            cluster: data.clusters[name],
                            isSingleLevel: isSingleLevel
                        }, name);
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: "No Data"
                    })
                })
            ]
        })
    });
};
CollapsibleTable.propTypes = {
    data: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (CollapsibleTable);


/***/ })

}]);